import React from 'react';
import SchoolInvitationsScreenEnhanced from '../../../../src/screens/school/SchoolInvitationsScreenEnhanced';

export default function InvitationsRoute() {
  return <SchoolInvitationsScreenEnhanced />;
}

